// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Spinner } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";
// CUSTOM COMPONENTS
// SERVICES AND HERLPERS
import constants from '../../../constants/constants';
import * as clientService from "../../../services/management/clientService";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { dashIfNull } from "../.../../../../helpers/helper";

const ClientListingPage = (props) => {
    const { auth } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (auth.isAdmin || auth.isProjectManager) {
            clientService.getClients().then(res => {
                setData(res);
            }).catch(ex => { })
                .finally(() => setLoading(false));
        }
    }, [])

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <NavLink
                            to={"/management/client-detail/" + data[dataIndex].id}
                            href="#"
                            className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                        >
                            Edit
                        </NavLink>
                    );
                }
            },

        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                filterType: 'multiselect',
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="tc-user-block">
                            <div
                                className="img-block background-image-container"
                                style={{ backgroundImage: `url(${data[dataIndex].logoPath ? (constants.API_URL + data[dataIndex].logoPath) : ("/media/users/default.jpg")})` }}
                            >
                            </div>

                            <div className="user-info-block">
                                <a className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                    {data[dataIndex].name}
                                </a>
                                <span className="text-muted font-weight-bold d-block">
                                    {dashIfNull(data[dataIndex].primaryPhone)}
                                </span>
                            </div>
                        </div>
                    )
                }
            }
        },
        // {
        //     name: "accountNumber",
        //     label: "Account #",
        //     options: {
        //         filter: true,
        //         filterType: 'multiselect',
        //         sort: true,
        //         customBodyRenderLite: (dataIndex) => {
        //             return (
        //                 <p>
        //                     {dashIfNull(data[dataIndex].accountNumber)}
        //                 </p>
        //             );
        //         }
        //     }
        // },
        {
            name: "address",
            label: "Address",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "city",
            label: "City",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "state",
            label: "State",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "zipCode",
            label: "Zipcode",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "locations",
            label: "Locations",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "isActive",
            label: "Is Active?",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <SVG
                                className="h-50 align-self-center"
                                src={toAbsoluteUrl(data[dataIndex].isActive === "True" ? "/media/svg/icons/Navigation/Check.svg" : "/media/svg/icons/Navigation/Close.svg")}
                            >
                            </SVG>
                        </>
                    );
                }
            }
        },
    ];

    return (
        <div className="row">
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Clients
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Clients
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            <NavLink
                                to={"/management/add-client"}
                                className="btn btn-success font-weight-bolder font-size-sm mr-3"
                            >
                                <span className="svg-icon svg-icon-lg svg-icon-white">
                                    <SVG
                                        src={toAbsoluteUrl(
                                            "/media/svg/icons/Code/Plus.svg"
                                        )}
                                    />
                                </span> Add Client
                            </NavLink>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                downloadOptions: {
                                    filename: 'Clients.csv',
                                    filterOptions: {
                                        useDisplayedColumnsOnly: true,
                                        useDisplayedRowsOnly: true
                                    }
                                },
                                textLabels: {
                                    body: {
                                        noMatch: loading ?
                                            <Spinner animation="border" size="lg" variant="info" /> :
                                            'Sorry, no matching records found.',
                                    },
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(ClientListingPage);